import React from 'react';
import { omit } from 'lodash';
import PropTypes from 'prop-types';

import CouponComponent from './CouponComponent';

class ListCouponsComponent extends React.Component {
    renderNoCoupons = () => (this.props.noCouponText ? this.props.noCouponText : null);

    renderList = () =>
        this.props.coupons.length > 0 &&
        this.props.coupons.map((coupon, i) => (
            <CouponComponent
                key={coupon.id}
                coupon={coupon}
                onClick={this.props.onItemClick}
                {...omit(this.props, ['coupons', 'onItemClick'])}
            />
        ));

    render() {
        return (
            <div>
                {this.renderList()}
                {this.renderNoCoupons()}
            </div>
        );
    }
}

ListCouponsComponent.propTypes = {
    coupons: PropTypes.array.isRequired,
    i18n: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    partnerId: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    onItemClick: PropTypes.func
};

export default ListCouponsComponent;



// WEBPACK FOOTER //
// ./src/components/coupon/ListCouponsComponent.js